function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "icomoon-ignore"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.686 16.925c0.021 0.026 0.050 0.048 0.073 0.073 0.294 0.364 0.737 0.602 1.241 0.602 0.883 0 1.599-0.715 1.599-1.599 0-0.47-0.206-0.887-0.527-1.18-0.042-0.047-0.080-0.095-0.142-0.142l-6.463-4.918c-0.188-0.145-0.459-0.152-0.656 0-0.235 0.181-0.279 0.519-0.098 0.754l4.972 6.41z",
  fill: "#000000"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 2.673c-0.175 0-0.346 0.020-0.519 0.026v0.553h-0.015v5.816h1.066v-5.302c6.514 0.282 11.729 5.653 11.729 12.234 0 6.761-5.5 12.261-12.262 12.261s-12.262-5.5-12.262-12.261c0-3.381 1.375-6.446 3.596-8.666l-0.758-0.758c-2.413 2.411-3.905 5.744-3.905 9.424 0 7.361 5.966 13.327 13.328 13.327s13.328-5.966 13.328-13.327c0-7.361-5.966-13.327-13.328-13.327z",
  fill: "#000000"
});

var SvgTimer = function SvgTimer(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTimer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timer.d6fba310.svg";
export { ForwardRef as ReactComponent };